import { ExtraOptions, RouterModule, Routes } from "@angular/router";
import { ModuleWithProviders } from "@angular/core";
import { AuthGuard } from "./auth/auth-guard.service";

import {
  AuthComponent,
  LoginComponent,
  LoginTokenComponent,
  RequestPasswordComponent,
  ResetPasswordComponent,
  LoginKeyComponent,
} from "./auth";

// Routes
const routes: Routes = [
  // routes
  {
    path: "auth",
    component: AuthComponent,
    children: [
      {
        path: "",
        component: LoginComponent,
      },
      {
        path: "login",
        component: LoginComponent,
      },
      {
        path: "acesso/:token",
        component: LoginTokenComponent,
      },
      {
        path: "request-password",
        component: RequestPasswordComponent,
      },
      {
        path: "reset-password",
        component: ResetPasswordComponent,
      },
      {
        path: "access-key/:key",
        component: LoginKeyComponent,
      },
    ],
  },
  {
    path: "pages",
    canActivate: [AuthGuard],
    loadChildren: "./pages/pages.module#PagesModule",
  },
  { path: "", redirectTo: "auth", pathMatch: "full" },
];

const config: ExtraOptions = {
  useHash: true,
};

export const AppRoutingModule: ModuleWithProviders = RouterModule.forRoot(
  routes,
  config
);



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts